import Axios from '@/axios';

// 查询识别记录
export const getRecognRecords = params => {  
  return Axios({
    url: '/face/web/record/index_record',
    method: 'GET',
    type: 'json',
    params
  })
}